<template>
  <section class="banners">
    <div class="banner-container">
      <div class="banner-item">
        <img src="@/assets/img/banner-1.jpg" alt="banner-1">
        <!-- <div class="banner-content">
          <p>New Arrival</p>
          <h2>CHIC & CITY<br>時髦都會系列</h2>
          <p>高雅優美，現正流行的簡約質感單品。</p>
          <router-link to="/products" class="btn">前往購買</router-link>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Banner'
}
</script> 

<style scoped>
.banners {
    height: calc(100vh - 80px);
    margin-top: 80px;
}

.banners .banner-container {
    height: 100%;
}

.banners .banner-container .banner-item {
    height: 100%;
    overflow: hidden;
    position: relative;
}

.banners .banner-container .banner-item img {
    width: 100%;
    object-fit: cover;
}

.banners .banner-container .banner-content {
    position: absolute;
    top: 45%;
    left: 5%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.banners .banner-container .banner-content h2 {
    font-size: 3.5rem;
    font-weight: 700;
    color: #FFFFFF;
    text-shadow: 2px 2px 3px #000000;
    margin: 0;
}

.banners .banner-container .banner-content p {
    font-size: 1.2rem;
    font-weight: 300;
    color: #FFFFFF;
    text-shadow: 0 0 10px #FFFFFF;
    margin: 0;
}

.banners .banner-container .banner-content a.btn {
    background-color: #F99393;
    padding: 0.8rem 1.5rem;
    border-radius: 30px;
    color: #FFFFFF;
    text-decoration: none;
    font-size: 1.5rem;
    font-weight: 700;
    box-shadow: 1px 1px 3px #000000;
    width: fit-content;
    margin-top: 1.5rem;
}
</style>